import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {ReceivablesPaymentImportRow} from "../../../../shared/interface/receivables-payment-import-row";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ReplaySubject} from "rxjs";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormHelperService} from "../../../../shared/services/form-helper.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {HttpErrorResponse} from "@angular/common/http";
import {ReceivablesPaymentImportRowService} from "../../../../shared/services/receivables-payment-import-row.service";


export interface ChangeStatementDialogData {
  receivablesPaymentImportsRowObject: ReceivablesPaymentImportRow;
}

@Component({
  selector: 'app-change-statement-dialog',
  templateUrl: './change-statement-dialog.component.html',
  styleUrls: ['./change-statement-dialog.component.scss']
})
export class ChangeStatementDialogComponent implements OnInit, OnDestroy {

  changeReceivablesBalanceForm: FormGroup;
  receivablesBalanceControl: FormControl;
  receivablesPaymentImportRowObject: ReceivablesPaymentImportRow;
  formErrors = {};
  processingRequest = false;


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);


  constructor(
    public dialogRef: MatDialogRef<ChangeStatementDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ChangeStatementDialogData,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private snack: MatSnackBar,
    private receivablesPaymentImportRowService: ReceivablesPaymentImportRowService,
  ) {
    this.receivablesPaymentImportRowObject = data.receivablesPaymentImportsRowObject;
    this.changeReceivablesBalanceForm = fb.group({
      receivablesBalance: this.receivablesBalanceControl = fb.control('', [Validators.required]),
    });
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  sendForm(): void {
    if (!this.changeReceivablesBalanceForm.valid) {
      this.changeReceivablesBalanceForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }
    if (this.processingRequest){
      return;
    }
    this.processingRequest = true;
    this.formHelper.removeBackendErrorState(this.changeReceivablesBalanceForm, this.formErrors);
    this.formErrors = {};

    this.receivablesPaymentImportRowService.changeReceivablesBalance(this.changeReceivablesBalanceForm.value, this.receivablesPaymentImportRowObject.uuid)
      .subscribe(() => {
        this.snack.open('Pomyślnie zaktualizowano obiekt', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.dialogRef.close();
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;

        if (error.status === 200) {
          this.snack.open('Pomyślnie zaktualizowano obiekt', '', {
            duration: 2000,
          });
          this.processingRequest = false;
          this.dialogRef.close();
        }

        this.snack.open('Podczas aktualizacji obiektu wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.changeReceivablesBalanceForm, this.formErrors);
        }
      })
    ;
  }

  closeDialog(e): void {
    this.dialogRef.close(e);
  }
}
